<template>
  <vue-date-picker
    v-model="date"
    @update:model-value="onUpdateDate()"
    model-type="MM/dd/yyyy"
    :teleport="true"
    position="right"
    :auto-apply="true"
    :close-on-auto-apply="false"
    :enable-time-picker="false"
  />
</template>

<script lang="ts" setup>
import { ref, watch } from "vue";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";

const props = defineProps(["date", "disabled"]);
const emit = defineEmits(["updateDate", "clearDate"]);
const date = ref(props.date);
const onUpdateDate = () => {
  emit("updateDate", date.value);
};

watch(
  () => props.date,
  (dateValue) => {
    date.value = dateValue;
  },
);
</script>
